import React, { useState, useEffect } from 'react';
import Quiz from './quiz';
import Result from './result';
import './App.css'; // Dodaj dla stylów
//import question from './question-planowanie-eksp';
import SettingsIcon from '@mui/icons-material/Settings';
import Progressbar from "./progressbar";
import Information from './information';

const App = () => {
  const [score, setScore] = useState(0);
  const [currentQuestionID, setCurrentQuestionID] = useState(0);
  const [isAnswer, setIsAnswer] = useState(false);
  const [answer, setAnswer] = useState(null);
  const [result, setResult] = useState(false);
  const [shuflequestion, setShuflequestion] = useState([]);
  const [skiped, setSkiped] = useState(0);
  const [ActualyQuestionNumber, setActualyQuestionNumber] = useState(0);
  const [badquestion, setBadquestion] = useState(0);
  const [choiceScreen, setChoiceScreen] = useState(true);
  const [choice, setChoice] = useState(null);
  const [totalQuestions, setTotalQuestions] = useState(0);


  const shufleArray = (arr) =>{
    const shuflequestion = [...arr]
    for (let i = 0; i<shuflequestion.length; i++) {
      let j = Math.floor(Math.random() * shuflequestion.length);
      [shuflequestion[i], shuflequestion[j]] = [shuflequestion[j], shuflequestion[i]]
    }
    for (let i = 0; i<shuflequestion.length; i++){
      for (let j = 0; j < shuflequestion[i].options.length; j++){
        let k = Math.floor(Math.random()*shuflequestion[i].options.length);
        [shuflequestion[i].options[j], shuflequestion[i].options[k]] = [shuflequestion[i].options[k], shuflequestion[i].options[j]]
      }
    }
    return(shuflequestion)
  }
  /*useEffect(() => {
    setquestion();
  }, []);*/
  const setquestion = async (choice)=>{
    try {
      const fileName = choice === 'bazy-danych' ? './question-bazy-danych.json' : './question-biostatystyka.json';
      const response = await fetch(`/${fileName}`);
      if (!response.ok) {
        throw new Error(`Nie udało się załadować pliku: ${fileName}`);
      }
      const questions = await response.json();
      setTotalQuestions(questions.length);
      setShuflequestion(shufleArray(questions));
    } catch (error) {
      console.error('Błąd podczas ładowania pytań:', error);
    }
  };
  const answered = (answer) => {
    setAnswer(answer);
    setIsAnswer(true);
  }
  const idn = () =>{
    setSkiped(skiped + 1);
    setAnswer(null);
    setIsAnswer(true);
  }

  const choiceButton = (e) =>{
    setChoice(e.target.name);
    setChoiceScreen(false);
    setquestion(e.target.name);
  }
  
  const Nextquestion = () => {
    const currquestion = shuflequestion[currentQuestionID];
    if (answer === currquestion.correctAnswer) {
      setScore(score + 1);
    }else if (answer !== null){
      setBadquestion(badquestion + 1);
    }
    setActualyQuestionNumber(ActualyQuestionNumber + 1);
    console.log(answer);
    console.log(score);
    setTimeout(() => {
      setAnswer(null);
      setIsAnswer(false);
      if (currentQuestionID < totalQuestions - 1) {
        setCurrentQuestionID(currentQuestionID + 1);
      }else{
        setResult(true);
      }
    }, 1000);
  };
  const Restart = () =>{
    setScore(0);
    setCurrentQuestionID(0);
    setResult(false);
    setAnswer(null);
    setIsAnswer(false);
    setActualyQuestionNumber(0);
    setBadquestion(0);
    setSkiped(0);
    setChoiceScreen(true);
    //setquestion();
  };
  if(shuflequestion.length === 0 && choiceScreen === false){
    return <div className="container">Ładowanie pytań proszę czekać...</div>
  }
  return (
      <div className="App">
        {choiceScreen ? (
            <div className="choice container">
                <button className="button-choices" id="bazy-danych" name="bazy-danych" onClick={choiceButton}>Medyczne Bazy danych</button>
                <button className="button-choices" id="biostatystyka" name="biostatystyka" onClick={choiceButton}>Biostatystyka</button>
            </div>
        ):(<>
        <Information isVisible={!result} badquestion={badquestion} actualyquestion={ActualyQuestionNumber} maxQuestion={totalQuestions} skiped={skiped} />
        <div className="container">
          <h1>Test wiedzy z {choice === 'bazy-danych'? "medycznych baz danych":"biostatystyki"}</h1>
          {!result ? (
              <div id="quiz">
                <Quiz question={shuflequestion[currentQuestionID]} onAnswerSelect={answered} showResult={isAnswer} />
                <button id="I-dont-know" onClick={idn} disabled={isAnswer}>Nie wiem 😿</button>
                <button id="next-question-button" onClick={Nextquestion} disabled={!isAnswer}>Następne pytanie</button>
              </div>
          ):(
              <Result score={score} onRestart={Restart} totalQuestions={totalQuestions} skiped={skiped} />
          )}
          <Progressbar isVisible={!result} Actualyquestion={ActualyQuestionNumber} maxQuestion={totalQuestions} />
        </div></>
        )};
      </div>
  );
};

export default App;